import { ArrowUpDown, ArrowUp, ArrowDown } from 'lucide-react'
import { TableHead } from '@/components/ui/table'
import { cn } from '@/lib/utils'

/**
 * TableHead con funzionalità di ordinamento.
 * 
 * @param {Object} props
 * @param {string} props.field - Nome del campo per l'ordinamento (es: 'nome', 'created_at')
 * @param {string} props.currentOrdering - Ordinamento corrente (es: 'nome', '-nome')
 * @param {Function} props.onSort - Callback quando si clicca per ordinare
 * @param {string} props.className - Classi CSS aggiuntive
 * @param {React.ReactNode} props.children - Contenuto della cella header
 */
export function SortableTableHead({ 
  field, 
  currentOrdering, 
  onSort, 
  className,
  children,
  ...props 
}) {
  const isActive = currentOrdering === field || currentOrdering === `-${field}`
  const isDesc = currentOrdering === `-${field}`
  
  const handleClick = () => {
    if (!onSort) return
    
    if (currentOrdering === field) {
      // Già ordinato asc -> passa a desc
      onSort(`-${field}`)
    } else if (currentOrdering === `-${field}`) {
      // Già ordinato desc -> torna ad asc
      onSort(field)
    } else {
      // Non ordinato -> ordina asc
      onSort(field)
    }
  }
  
  const renderIcon = () => {
    if (!isActive) {
      return <ArrowUpDown className="h-4 w-4 text-muted-foreground/50" />
    }
    if (isDesc) {
      return <ArrowDown className="h-4 w-4 text-primary" />
    }
    return <ArrowUp className="h-4 w-4 text-primary" />
  }
  
  return (
    <TableHead
      className={cn(
        'cursor-pointer select-none hover:bg-muted/50 transition-colors',
        isActive && 'bg-muted/30',
        className
      )}
      aria-sort={isActive ? (isDesc ? 'descending' : 'ascending') : 'none'}
      {...props}
    >
      <button type="button" onClick={handleClick} className={cn('flex items-center gap-1 w-full text-left', className?.includes('text-right') && 'justify-end', className?.includes('text-center') && 'justify-center')} aria-label={`Ordina per ${typeof children === 'string' ? children : field}`}>
        {children}
        {renderIcon()}
      </button>
    </TableHead>
  )
}

export default SortableTableHead
